"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _Select = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Select"));
var _InputField = _interopRequireDefault(require("@kiwicom/orbit-components/lib/InputField"));
var _InputGroup = _interopRequireDefault(require("@kiwicom/orbit-components/lib/InputGroup"));
var _getDate = _interopRequireDefault(require("date-fns/getDate"));
var _getMonth = _interopRequireDefault(require("date-fns/getMonth"));
var _getYear = _interopRequireDefault(require("date-fns/getYear"));
var _isValid = _interopRequireDefault(require("date-fns/isValid"));
var _endOfMonth = _interopRequireDefault(require("date-fns/endOfMonth"));
var _months = _interopRequireDefault(require("../../consts/months"));
var _errors = _interopRequireDefault(require("../../consts/errors"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
class DateInput extends React.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "getDefaultError", () => {
      const {
        intl
      } = this.props;
      const {
        date,
        month,
        year,
        dateFilled,
        monthFilled,
        yearFilled
      } = this.state;
      if (!(dateFilled && monthFilled && yearFilled)) {
        return null;
      }
      if (date && month && year) {
        const value = this.getDateObject();
        if (!(0, _isValid.default)(value)) {
          return intl.formatMessage(_errors.default.invalidDate);
        }
      }
      return null;
    });
    (0, _defineProperty2.default)(this, "updateDate", () => {
      const {
        onChange
      } = this.props;
      const date = this.getDateObject();
      onChange((0, _isValid.default)(date) ? date : null);
    });
    (0, _defineProperty2.default)(this, "handleChange", ev => {
      const target = ev.target;
      const {
        value,
        name: fieldName
      } = target;
      if (fieldName === "date") {
        this.setState({
          date: value
        }, this.updateDate);
      } else if (fieldName === "month") {
        this.setState({
          month: value
        }, this.updateDate);
      } else {
        this.setState({
          year: value
        }, this.updateDate);
      }
    });
    (0, _defineProperty2.default)(this, "handleBlur", ev => {
      const target = ev.target;
      const fieldName = target.name;
      if (fieldName === "date") {
        this.setState({
          dateFilled: true
        });
      } else if (fieldName === "month") {
        this.setState({
          monthFilled: true
        });
      } else {
        this.setState({
          yearFilled: true
        });
      }
    });
    const {
      value: _value
    } = props;
    this.state = {
      date: _value ? String((0, _getDate.default)(_value)) : "",
      month: _value ? String((0, _getMonth.default)(_value)) : "",
      year: _value ? String((0, _getYear.default)(_value)) : "",
      dateFilled: false,
      monthFilled: false,
      yearFilled: false
    };
  }
  getDateObject() {
    const {
      date,
      month,
      year
    } = this.state;
    if (date && month && year) {
      const d = Number(date);
      const m = Number(month);
      const y = Number(year);

      // only meaningful full year is allowed to not interpret 12 as 1912
      if (y < 1900) {
        return null;
      }
      const dateObject = new Date(y, m, d);

      // date has to be valid day of month
      if (dateObject > (0, _endOfMonth.default)(new Date(y, m))) {
        return null;
      }
      return dateObject;
    }
    return null;
  }
  render() {
    const {
      label,
      error,
      disabled,
      intl
    } = this.props;
    const {
      date,
      month,
      year
    } = this.state;
    const errorMessage = error !== null && error !== void 0 ? error : this.getDefaultError();
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_InputGroup.default, {
      error: errorMessage,
      label: label,
      disabled: disabled !== null && disabled !== void 0 ? disabled : false,
      flex: ["0 0 60px", "1 1 100%", "0 0 90px"],
      onChange: this.handleChange,
      onBlur: this.handleBlur,
      dataTest: "DateInput",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_InputField.default, {
        name: "date",
        placeholder: intl.formatMessage({
          id: "account.date_input.date_placeholder"
        }),
        type: "number",
        inputMode: "decimal",
        value: date,
        dataTest: "DateInput-Date"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Select.default, {
        name: "month",
        options: _months.default.map((monthLabel, i) => ({
          value: i,
          label: intl.formatMessage(monthLabel)
        })),
        placeholder: intl.formatMessage({
          id: "account.date_input.select_month_placeholder"
        }),
        value: month,
        dataTest: "DateInput-Month"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputField.default, {
        name: "year",
        placeholder: intl.formatMessage({
          id: "account.date_input.year_placeholder"
        }),
        type: "number",
        inputMode: "decimal",
        value: year,
        dataTest: "DateInput-Year"
      })]
    });
  }
}
var _default = (0, _reactIntl.injectIntl)(DateInput);
exports.default = _default;